import { api } from '../services/api'
import { user } from '../helpers/user'
import { useToast } from '@chakra-ui/react'

export const useCallPhone = () => {
  const toast = useToast({
    position: 'top-right',
  })

  const callPhone = async (phone) => {
    if (!phone) {
      throw new Error('Número de telefone inválido')
    }

    if (phone.length < 8) {
      throw new Error('Número de telefone inválido')
    }

    phone = phone.replace(/\D/g, '')

    try {
      const response = await api.post('/contato/abrir-ligacao', {
        numero_chamada: phone,
        id_ramal: user.id_ramal,
        hash_pass: user.hash_pass,
        codigo_vendedor: user.codigo_vendedor,
      })

      toast({
        title: 'Ligação realizada com sucesso',
        description: `Você está ligando para o número ${phone}, vá até o seu telefone e atenda a ligação.`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      })

      return response.data
    } catch (error) {
      console.log(error)

      toast({
        title: 'Erro ao realizar ligação',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
  }

  return {
    callPhone,
  }
}
